import { Form, FormField, FormSection, FormType } from '../../../../../common/components/reactive-form-builder/interfaces/form.interface';
import { ParcelasEnvironmentDefinition } from '../environment-variables';
import { ParcelasListsDefinition } from './list-variables';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { ParcelasModel } from '../../../../../models/form-common/parcelas.model';
import { FullMapModel } from '../../../../../models/form-common/full-map.model';
import { FormRequestTypes } from '../../../../../common/components/reactive-form-builder/form-request';
import { DropdownData, InputType } from '../../../../../common/components/reactive-form-builder/interfaces/input.interface';
import { SectorModel } from '../../../../../models/form-common/sector.model';
import { FilteredValuesInterface } from '../../../../../common/components/form-builder/form-builder.component';
import { VisitasVariedadMesModel } from '../../../../../models/visitas_variedad_mes/visitas_variedad_mes.model';
import { list } from '../../../../../common/classes/request-builder';
import { DialogSigPacComponent } from './dialog/dialog.sigpac.component';
import { environment } from '../../../../../../environments/environment';

export class ParcelasFormDefinition {
    public sigpacDialog: DialogSigPacComponent | undefined;
    
    public formType!: FormType;
    public env: ParcelasEnvironmentDefinition = new ParcelasEnvironmentDefinition();
    public lists: ParcelasListsDefinition = new ParcelasListsDefinition();

    public cliente = StorageManager.getClient();
    public usuario = StorageManager.getUser();

    public model: ParcelasModel = {
        activo: '1',
        turbo: '1',
        mapa: [{} as FullMapModel] 
    } as ParcelasModel;

    public tag = '';
    
    public formFieldsDatosParcela!: FormSection<object>;
    public formFieldsNumMetros!: FormSection<object>;
    public formFieldsDatosParcelaOtros!: FormSection<object>;
    public formFieldsDatosSigpac!: FormSection<object>;
    public formFieldsDatosGenerales!: FormSection<object>;
    public formFieldsDatosMedioambientales!: FormSection<object>;
    public formFieldsZonasEspecificas!: FormSection<object>;
    
    public formFields!: Form<ParcelasModel>;
    public fieldNames: FormField<any>[] = [];
    public fieldLabels: string[] = [];

    public now = new Date();
    public day = this.now.getDate().toString().padStart(2, '0');
    public month = (this.now.getMonth() + 1).toString().padStart(2, '0');
    public year = this.now.getFullYear().toString();
    public hours = this.now.getHours().toString().padStart(2, '0');
    public minutes = this.now.getMinutes().toString().padStart(2, '0');

    public viewNumeroMetros = false;
    public mapaOpened = false;
    public mapaAbierto = false;

    public finca = 'finca';
    public localidad = 'localidad';
    public parcelaNombre = 'nombre parcela';
    public cultivo = 'cultivo';
    public variedad = 'variedad';
    
    constructor(
        type: FormRequestTypes, 
        _model: Record<string,string>,
        sigpacDialog: DialogSigPacComponent,
        table: (string[] | string[][])[] | null) {
        this.formType = +type;
        this.sigpacDialog = sigpacDialog; 
        this.model.cultivo = (
            (this.env.hasPlantas || !this.env.activateApiSIEX) ?
                this.lists.cultivosLegacy.selected?.cultivo :
                this.lists.cultivos.selected?.cultivo) ?? '';
        this.model.variedad = (
            (this.env.hasPlantas || !this.env.activateApiSIEX) ?
                this.lists.variedadesLegacy.selected?.variedad :
                this.lists.variedades.selected?.variedad) ?? '';


        this.formFields = {
            name: 'parcelas',
            type: this.formType,
            sections: this.getFormSections(),
            table: {data: table?.[0], style: table?.[1]},
            uploadButton: false,
            signed: false
        };
    }


    public getDatosParcelaFields() {
        const datosParcelaFields: FormField<any>[] = [
            {
                name: 'id_finca',
                vinculatedFields: undefined,
                label: this.env.fincaName,
                input: {
                    type: InputType.DROPDOWN_SEARCH, 
                    data: this.lists.fincas,
                    isEditable: true,
                    dropdownConfiguration: {valuePrimaryKey: 'id'}
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: true,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 1
            },
            {
                name: 'id_sector',
                vinculatedFields: ['id_finca'],
                label: this.env.sectorName,
                input: {
                    type: InputType.DROPDOWN, 
                    data: this.lists.sectores,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it: FilteredValuesInterface<SectorModel>) => it.value?.id_finca === (this.lists.fincas.selected || {}).id,
                    },
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showSectores
                },
                order: 2
            },
            {
                name: 'numero_parcela_agricola',
                vinculatedFields: undefined,
                label: 'Número de Parcela Agrícola',
                input: { type: InputType.NUMERIC, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agropecuariaramirogruas' || this.env.appName === 'prodalbar'
                },
                order: 3
            },
            {
                name: 'pendiente',
                vinculatedFields: undefined,
                label: '% Pendiente',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agropecuariaramirogruas'
                },
                order: 4
            },
            {
                name: 'id_cultivo',
                vinculatedFields: undefined,
                label: this.env.appName === 'momparler' ?
                    'Género/Especie SIEX' :
                    this.env.showTareasMto ?
                        'Especie SIEX' :
                        'Cultivo SIEX',
                input: { 
                    type: InputType.DROPDOWN_SEARCH,
                    data: this.lists.cultivos,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it: FilteredValuesInterface<VisitasVariedadMesModel>) => {
                            if (this.env.appName === 'yagoaznar') {
                                const cultivoEncontrado = 
                                    this.lists.filtroCultivosYagoAznar.find((cultivo) => cultivo === it.value?.cultivo);
        
                                if (cultivoEncontrado) {
                                    return true;
                                }
                            } else {
                                return true;
                            }
                            return false;
                        },
                        appendData: (field: FormField<VisitasVariedadMesModel>) => {
                            const dropdown = field.input?.data as DropdownData<VisitasVariedadMesModel>;
                                if (!dropdown || !this.env.hasCultivosPropios) return;

                                const cultivosPropios = (this.lists.cultivosLegacy.values ?? []).map(item => ({
                                    label: item.value?.cultivo,
                                    value: item.value
                                }));

                                const existingItems = dropdown.values ?? [];

                                const getId = (entry: any) => entry?.value?.id;

                                // 🔎 Busca el separador (amb label "..." o value === null)
                                const separator = existingItems.find(item => item.label === "..." || item.value === null);

                                // 🧹 Cultius que no són de cultivosLegacy ni separador
                                const propiosIds = new Set(cultivosPropios.map(getId));
                                const restants = existingItems.filter(item =>
                                    !propiosIds.has(getId(item)) && item !== separator
                                );

                                // 🧩 Construcció final: [propios, separador, restants]
                                dropdown.values = [
                                    ...cultivosPropios,
                                    ...(separator ? [separator] : []),
                                    ...restants
                                ] as any;

                                dropdown.filtered = [...dropdown.values];
                                dropdown.filtered = dropdown.filtered.slice(1);
                        }

                    },
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: !this.env.showTareasMto && this.env.appName !== 'agrosalvi' && this.env.appName !== 'detorres',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.activateApiSIEX
                },
                order: 5,
            },
            {
                name: 'id_variedad',
                vinculatedFields: undefined,
                label: 'Variedad SIEX',
                input: { 
                    type: InputType.DROPDOWN_SEARCH, 
                    data: this.lists.variedades,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it: FilteredValuesInterface<VisitasVariedadMesModel>) => 
                            it.value?.codigo_cultivo === (this.lists.cultivos.selected || {}).codigo,
                        appendData: (field: FormField<VisitasVariedadMesModel>) => {
                            if (!this.env.hasCultivosPropios) return;

                            const cultivoSeleccionado = this.lists.cultivos.selected;
                            if (!cultivoSeleccionado?.codigo) return;

                            const dropdown = field.input?.data as DropdownData<VisitasVariedadMesModel>;
                            if (!dropdown) return;

                            const getId = (entry: any) => entry?.value?.id;

                            // Legacy del cultiu seleccionat
                            const legacyVariedades = (this.lists.variedadesLegacy.values ?? [])
                                .filter(item => item.value?.codigo_cultivo === cultivoSeleccionado.codigo)
                                .map(item => ({
                                    label: item.value?.variedad,
                                    value: item.value
                                }));

                            // Totes les varietats disponibles (amb o sense filtre)
                            const allItems = dropdown.values ?? [];

                            // Separador (agafa'l si ja existeix o crea'l)
                            const separator = allItems.find(item => item.label === "..." && item.value === null) 
                                ?? { label: "...", value: null };

                            // Obtenir varietats normals del mateix cultiu, excloent duplicats i separador
                            const legacyIds = new Set(legacyVariedades.map(getId));
                            const variedadesNormales = allItems.filter(item =>
                                item.value?.codigo_cultivo === cultivoSeleccionado.codigo &&
                                !legacyIds.has(getId(item)) &&
                                !(item.label === "..." && item.value === null)
                            );

                            // Assignació final
                            dropdown.filtered = [
                                ...legacyVariedades,
                                separator,
                                ...variedadesNormales
                            ] as any;
                        }
                    }
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: (!this.env.variedadCanBeVarios && !this.env.showTareasMto) && this.env.appName !== 'agrosalvi',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.activateApiSIEX,
                },
                order: 6,
            },
            {
                name: 'id_cultivo_legacy',
                vinculatedFields: undefined,
                label: this.env.appName === 'momparler' ? 'Género/Especie' : this.env.showTareasMto ? 'Especie' : 'Cultivo',
                input: {
                    type: InputType.DROPDOWN_SEARCH, 
                    data: this.lists.cultivosLegacy,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id'
                    } 
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: !this.env.showTareasMto && this.env.appName !== 'agrosalvi',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showCultivosVariedadesPropios ? (this.env.hasPlantas || !this.env.activateApiSIEX) : false
                },
                order: 7
            },
            {
                name: 'id_variedad_legacy',
                vinculatedFields: ['id_cultivo_legacy'],
                label: 'Variedad',
                input: { 
                    type: InputType.DROPDOWN_SEARCH, 
                    data: this.lists.variedadesLegacy,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it: FilteredValuesInterface<VisitasVariedadMesModel>) => {
                            const match = it.value?.cultivo === (this.lists.cultivosLegacy.selected || {}).cultivo;
            
                            if (match) {
                                this.lists.cultivosLegacy.selected = this.lists.cultivosLegacy.filtered
                                    .filter(c => c && c.value)
                                    .map(c => c.value)
                                    .find(cultivo => cultivo?.cultivo === it.value?.cultivo) as VisitasVariedadMesModel;
                            }
            
                            return match;
                        },
                    },
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: (!this.env.variedadCanBeVarios && !this.env.showTareasMto) && this.env.appName !== 'agrosalvi',
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showCultivosVariedadesPropios ? (this.env.hasPlantas || !this.env.activateApiSIEX) : false
                },
                order: 8
            },
            {
                name: 'marco',
                vinculatedFields: undefined,
                label: this.env.appName === 'cartagenafresh' ? 'Nº Cintas Riego' : 'Marco Plantación (Filas x Plantas)',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showMarcoPlantacion
                },
                order: 9
            },
            {
                name: 'pies',
                vinculatedFields: undefined,
                label: 'Pies',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'yagoaznar'
                },
                order: 10
            },
            {
                name: 'anyo_plantacion',
                vinculatedFields: undefined,
                label: this.env.appName === 'cartagenafresh' ? 'Semana Plantación' : 'Año Plantación',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showAnyoPlantacion
                },
                order: 11
            },
            {
                name: 'plantas',
                vinculatedFields: undefined,
                label: this.env.appName === 'cartagenafresh' ? 'Kg/Ha' : 'Nº Árboles/Plantas',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showPlantas
                },
                order: 12
            },
            {
                name: 'patron',
                vinculatedFields: undefined,
                label: (this.lists.cultivos.selected || {}).cultivo === 'VIÑA' ?
                    'Portainjertos' :
                    this.env.appName === 'momparler' ?
                        'Formato' :
                        this.env.appName === 'cartagenafresh' ?
                            'Cama' :
                            'Patrón',
                input: { 
                    type: InputType.DROPDOWN_SEARCH, 
                    data: this.env.appName === 'momparler' ? this.lists.formatoMomparler : 
                        this.env.appName === 'cartagenafresh' ? this.lists.cama : this.lists.patron,
                    isEditable: true,
                    dropdownConfiguration: {
                        swap: (it: FormField<object>) => {
                            it.input.data = this.getPatron(this.model.cultivo ?? '');
                            if (this.model.cultivo === 'viña') {
                                it.label = 'Portainjertos';
                            } else {
                                if (this.env.appName === 'momparler') {
                                    it.label = 'Formato';
                                    //this.parcelaNombreCultivo = cultivo;
                                } else {
                                    it.label = 'Patrón';
                                }
                            }
                        },
                    }
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showPatron
                },
                order: 13
            },
            {
                name: 'diametro_copa',
                vinculatedFields: undefined,
                label: 'Diámetro de Copa',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agufert'
                },
                order: 14
            },
            {
                name: 'captacion_agua',
                vinculatedFields: undefined,
                label: 'Captación Agua',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agropecuariaramirogruas'
                },
                order: 15
            },
            {
                name: 'zonas_especificas',
                vinculatedFields: undefined,
                label: 'Zonas Específicas',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agropecuariaramirogruas'
                },
                order: 16
            },
            {
                name: 'zona_vulnerable',
                vinculatedFields: undefined,
                label: 'Zona Vulnerable (ha)',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agropecuariaramirogruas'   
                },
                order: 17
            },
            {
                name: 'herbaceo_lenyoso',
                vinculatedFields: undefined,
                label: 'Herbáceo / Leñoso',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agropecuariaramirogruas'
                },
                order: 18
            },
            {
                name: 'producto',
                vinculatedFields: undefined,
                label: 'Producto',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'bravosol'
                },
                order: 19
            },
            {
                name: 'prevision_produccion',
                vinculatedFields: undefined,
                label: 'Previsión Producción',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'icod'
                },
                order: 20
            },
            {
                name: 'codigo_trazabilidad',
                vinculatedFields: undefined,
                label: 'Código de trazabilidad',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showParcelasCodigoTrazabilidad
                },
                order: 21
            },
            {
                name: 'lote',
                vinculatedFields: undefined,
                label: 'Nº lote',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showParcelasLote
                },
                order: 22
            },
            {
                name: 'pozo',
                vinculatedFields: undefined,
                label: 'Pozo',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf'
                },
                order: 23
            },
            {
                name: 'rios',
                vinculatedFields: undefined,
                label: 'Rios',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf'
                },
                order: 24
            },
            {
                name: 'estacion_control',
                vinculatedFields: undefined,
                label: 'Estación de control',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf'
                },
                order: 25
            },
            {
                name: 'regimen_tenencia',
                vinculatedFields: undefined,
                label: 'Régimen tenencia',
                input: { 
                    type: InputType.DROPDOWN_SEARCH, 
                    data: this.env.appName === 'prodalbar' ? this.lists.regimenTenenciaProdalbar : this.lists.regimenTenencia, 
                    isEditable: true 
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pyf' || this.env.appName === 'prodalbar'
                },
                order: 26
            },
            {
                name: 'produccion_ecologica',
                vinculatedFields: undefined,
                label: 'Producción Ecológica',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'prodalbar'
                },
                order: 27
            },
            {
                name: 'uds_bandeja',
                vinculatedFields: undefined,
                label: 'Uds. Bandeja',
                input: { 
                    type: InputType.DROPDOWN,
                    data: this.lists.uds_bandeja,
                    isEditable: true 
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'viverospereira'
                },
                order: 28
            },
            {
                name: 'distancia_menor_50',
                vinculatedFields: undefined,
                label: 'DISTANCIA MENOR A 50m',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agropecuariaramirogruas'
                },
                updateValue: (it: any) => it.input.data === 1 ?  this.viewNumeroMetros = true : false,
                order: 29
            },
            {
                name: 'tipo_siembra',
                vinculatedFields: undefined,
                label: 'Tipo de Siembra',
                input: { 
                    type: InputType.DROPDOWN, 
                    data: this.lists.tipoSiembra,
                    isEditable: true 
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'pedrosaez'
                },
                order: 30
            },
            {
                name: 'aplicadores',
                vinculatedFields: undefined,
                label: this.env.appName === 'avafitogest' ? 'Asesor' : 'Aplicadores',
                input: { 
                    type: this.env.appName === 'avafitogest' ? InputType.DROPDOWN : InputType.MULTISELECT,
                    data: this.lists.aplicadores,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id',
                        filter: (it: FilteredValuesInterface<any>) => {
                            if (
                                this.env.appName === 'sequiador' && 
                                it.value?.rol === 'responsable' && 
                                it.value.acceso_plataforma?.toString() === '1'
                            ) {
                                // Asesor la Comunidad de Regantes de Alfafar. Debe tener acceso a todos los cuadernos de campo.
                                if (it.value.nombre ===  'TONI') {
                                    if (this.lists.aplicadores.selected && this.lists.aplicadores.selected.indexOf(it.value) < 0) {
                                        this.lists.aplicadores.selected.push(it.value);
                                    }
                                }
                                return true;
                            }

                            if (this.env.appName === 'avafitogest' && it.value?.tipo_carnet === 'ASESOR') {
                                return true;
                            }
                            
                            return false;
                        }
                    }
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: (this.env.appName === 'sequiador' &&
                            (StorageManager.getUser().tipo === 'comunero' ||
                                StorageManager.getUser().rol === 'admin')) || this.env.appName === 'avafitogest',
                },
                order: 31
            },
            { 
                name: 'activo',
                vinculatedFields: undefined,
                label: 'Activo', 
                input: { type: InputType.SWITCH, defaultValue: '1', isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showAplicadoresActivo
                },
                order: 32
            },
            {
                name: 'procedencia_agua',
                vinculatedFields: undefined,
                label: 'Procedencia Agua/Origen',
                input: { 
                    type: InputType.DROPDOWN, 
                    data: list('Regeneración', 'Subterránea', 'Superficial'),
                    isEditable: true 
                },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.applicationType === 'cropgest',
                },
                order: 33
            },
            {
                name: 'linde',
                vinculatedFields: undefined,
                label: 'Linde',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.applicationType === 'cropgest'
                },
                order: 34
            },
            {
                name: 'gip',
                vinculatedFields: undefined,
                label: 'GIP',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.applicationType === 'cropgest'
                },
                order: 34
            },
            {
                name: 'masas_agua',
                vinculatedFields: undefined,
                label: 'Masas de agua superficie',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.applicationType === 'cropgest'
                },
                order: 34
            },
            {
                name: 'puntos_agua',
                vinculatedFields: undefined,
                label: 'Puntos de extracción de agua para consumo humano ',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.applicationType === 'cropgest'
                },
                order: 34
            },
            {
                name: 'codigo_DGC',
                vinculatedFields: undefined,
                label: 'Codigo DGC',
                input: { type: InputType.TEXT , isEditable: false },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: environment.features.activateREA
                },
                order: 35
            },
            {
                name: 'notas',
                vinculatedFields: undefined,
                label: 'Notas',
                input: { type: InputType.TEXTAREA, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agroleza'
                },
                order: 36
            }
        ];
        this.fieldNames = this.fieldNames.concat(datosParcelaFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(datosParcelaFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return datosParcelaFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getNumMetrosFields(isSectionVisible: boolean) {
        const numMetrosFields: FormField<any>[] = [
            {
                name: 'numero_metros',
                vinculatedFields: undefined,
                label: 'Número de Metros',
                input: { type: InputType.TEXT, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 1
            },
        ];
        this.fieldNames = this.fieldNames.concat(numMetrosFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(numMetrosFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return numMetrosFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getDatosParcelaOtrosFields(isSectionVisible: boolean) {
        const datosParcelaOtrosFields: FormField<any>[] = [
            { 
                name: 'partida', 
                vinculatedFields: undefined,
                label: 'Partida', 
                input: { type: InputType.TEXT, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showParcelasPartida
                },
                order: 1
            },
            {
                name: 'comercio',
                vinculatedFields: undefined,
                label: 'Comercio',
                input: { type: InputType.TEXT, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showParcelasComercio && !this.env.showParcelasComercioDropdown
                },
                order: 2
            },
            {
                name: 'comercio',
                vinculatedFields: undefined,
                label: 'Comercio',
                input: { 
                    type: InputType.TEXT,
                    data: this.lists.comercios,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'id'
                    }
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showParcelasComercioDropdown
                },
                order: 3
            },
            { 
                name: 'pozos',
                vinculatedFields: undefined, 
                label: 'Pozos', 
                input: { type: InputType.TEXT, isEditable: true }, 
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showParcelasPozos
                },
                order: 4
            },
            { 
                name: 'turbo', 
                vinculatedFields: undefined,
                label: this.model.turbo ? 'Turbo Sí' : 'Turbo No',
                input: { type: InputType.SWITCH, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible && this.env.showParcelasTurbo
                }, 
                order: 5
            },
        ];
        this.fieldNames = this.fieldNames.concat(datosParcelaOtrosFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(datosParcelaOtrosFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return datosParcelaOtrosFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getDatosSigpacFields() {
        const datosSigpacFields: FormField<any>[] = [
            {
                name: 'nombre',
                vinculatedFields: undefined,
                label: `Nombre ${this.env.appName === 'gardengest' ? 'del' : 'de la'} ${this.env.parcelaName}`,
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: true,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 1
            },
            {
                name: 'uso_sigpac',
                vinculatedFields: undefined,
                label: 'Uso SigPAC',
                input: { 
                    type: InputType.DROPDOWN_SEARCH, 
                    data: this.lists.usoSigpac,
                    isEditable: true 
                },
                updateValue: () => this.model.uso_sigpac,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 2
            },
            { 
                name: 'superficie_sigpac',
                vinculatedFields: undefined, 
                label: 'Superficie SigPAC (' + this.env.textoSuperficie + ')', 
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.superficie_sigpac,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 3
            },
            {
                name: 'superficie_cultivada',
                vinculatedFields: undefined,
                label: 'Superficie Cultivada (' + this.env.textoSuperficie + ')',
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 4
            },
            { 
                name: 'cod_provincia',
                vinculatedFields: undefined, 
                label: 'Cod. Provincia', 
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.cod_provincia,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 5
            },
            { 
                name: 'municipio',
                vinculatedFields: undefined, 
                label: 'Municipio', 
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.municipio,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 6
            },
            { 
                name: 'poligono', 
                vinculatedFields: undefined,
                label: 'Polígono',
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.poligono,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 7
            },
            { 
                name: 'numero',
                vinculatedFields: undefined, 
                label: 'Nº Parcela', 
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.numero,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 8
            },
            { 
                name: 'recinto',
                vinculatedFields: undefined, 
                label: 'Recinto', 
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.recinto,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                }, 
                order: 9
            },
            { 
                name: 'agregado', 
                vinculatedFields: undefined,
                label: 'Agregado', 
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 10
            },
            { 
                name: 'orden',
                vinculatedFields: undefined, 
                label: 'Zona', 
                input: { type: InputType.TEXT, isEditable: true },
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                }, 
                order: 11
            },
            { 
                name: 'sigpac',
                vinculatedFields: undefined, 
                label: 'SigPAC', 
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.sigpac,
                width: 3,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 12
            },
            { 
                name: 'coordenadas', 
                vinculatedFields: undefined,
                label: 'Coordenadas', 
                input: { type: InputType.TEXT, isEditable: true },
                updateValue: () => this.model.mapa?.[0]?.coordenadas ?? '',
                width: 3, 
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'agrosalvi'
                },
                order: 13
            }
        ];
        this.fieldNames = this.fieldNames.concat(datosSigpacFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(datosSigpacFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return datosSigpacFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getDatosGeneralesFields() {
        const datosGeneralesFields: FormField<any>[] = [
            { 
                name: 'codigo_secano_regadio', 
                vinculatedFields: undefined,
                label: 'Secano / Regadío', 
                input: { 
                    type: InputType.DROPDOWN, 
                    data: this.lists.secanoRegadio,
                    isEditable: true 
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 1
            },
            {
                name: 'codigo_sistema_riego',
                vinculatedFields: ['codigo_secano_regadio'],
                label: 'Sistema de Riego',
                input: { 
                    type: InputType.DROPDOWN, 
                    data: this.lists.sistemasRiego,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'codigo_SIEX',
                        filter: () => this.lists.secanoRegadio.selected === 'R',
                    },
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true   
                },
                order: 2
            },
            {
                name: 'zona_riego',
                vinculatedFields: undefined,
                label: 'Zona de Riego',
                input: { 
                    type: InputType.DROPDOWN, 
                    data: list('...', 'Zona Alta', 'Zona Baja'),
                    isEditable: true,
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.appName === 'avafitogest'   
                },
                order: 3
            },
            {
                name: 'codigo_sistema_cultivo',
                vinculatedFields: undefined,
                label: 'Sistema de Cultivo',
                input: { 
                    type: InputType.DROPDOWN, 
                    data: this.lists.sistemasCultivo,
                    isEditable: true
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true   
                },
                order: 4
            },
            {
                name: 'codigo_observaciones_forestales',
                vinculatedFields: ['codigo_sistema_cultivo'],
                label: 'Observaciones de Forestales',
                input: { 
                    type: InputType.DROPDOWN, 
                    data: this.lists.observacionesForestales,
                    isEditable: true,
                    dropdownConfiguration: {
                        valuePrimaryKey: 'codigo',
                    }
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true   
                },
                order: 5
            },
            {
                name: 'sistema_asesoramiento',
                vinculatedFields: undefined,
                label: 'Sistema de asesoramiento',
                input: { 
                    type: InputType.DROPDOWN,
                    data: this.lists.sistemaAsesoramiento,
                    isEditable: true 
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true   
                },
                order: 6
            },
            {
                name: 'estacion',
                vinculatedFields: undefined,
                label: 'Estación',
                input: { 
                    type: InputType.DROPDOWN,
                    data: list(['...', null], ['I - Invierno', 'I'], ['P - Primavera', 'P'], ['V - Verano', 'V']),
                    isEditable: true 
                },
                width: 4,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.showParcelasEstacion && this.env.appName !== 'pyf'   
                },
                order: 6
            },
            
        ];
        this.fieldNames = this.fieldNames.concat(datosGeneralesFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(datosGeneralesFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return datosGeneralesFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getDatosMedioambientalesFields(isSectionVisible: boolean) {
        const datosMedioambientalesFields: FormField<any>[] = [
            { 
                name: 'incluido_en_parcela', 
                vinculatedFields: undefined,
                label: 'Incluido en la parcela', 
                input: { type: InputType.SWITCH, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 1
            },
            { 
                name: 'distancia',
                vinculatedFields: undefined, 
                label: 'Distancia (m3)',
                input: { type: InputType.TEXT, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 2
            },
            { 
                name: 'coordenadas_utm',
                vinculatedFields: undefined,
                label: 'Coordenadas UTM', 
                input: { type: InputType.TEXT, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 3
            },
            { 
                name: 'denominacion',
                vinculatedFields: undefined, 
                label: 'Denominación', 
                input: { type: InputType.TEXT, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 4 
            }
        ];
        this.fieldNames = this.fieldNames.concat(datosMedioambientalesFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(datosMedioambientalesFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return datosMedioambientalesFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    public getZonasEspecificasFields(isSectionVisible: boolean) {
        const zonasEspecificasFields: FormField<any>[] = [
            { 
                name: 'zona_total', 
                vinculatedFields: undefined,
                label: 'Totalmente', 
                input: { type: InputType.SWITCH, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 1
            },
            { 
                name: 'zona_parcial', 
                vinculatedFields: undefined,
                label: 'Parcialmente', 
                input: { type: InputType.SWITCH, isEditable: true },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: isSectionVisible
                },
                order: 2
            }
        ];
        this.fieldNames = this.fieldNames.concat(zonasEspecificasFields.filter((it) => it.conditions.isVisible));
        this.fieldLabels = this.fieldLabels.concat(zonasEspecificasFields.filter((it) => it.conditions.isVisible).map(it => it.label));
        return zonasEspecificasFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    
    private getFormSections() {
        const sections: FormSection<any>[] = [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getDatosParcelaFields(),
                order: 1
            },
            {
                name: '',
                width: 12,
                isVisible: this.viewNumeroMetros,
                fields: this.getNumMetrosFields(this.viewNumeroMetros),
                order: 2
            }, 
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getDatosParcelaOtrosFields(this.env.otros),
                order: 3
            },
            {
                name: 'Datos SigPAC',
                width: 12,
                isVisible: true,
                fields: this.getDatosSigpacFields(),
                buttons: [{
                    class: 'btn btn-warning',
                    style: 'margin-left:0px !important',
                    icon: 'fa fa-search',
                    label: ' Mapa',
                    function: () => this.abreMapa()
                },
                {
                    class: 'btn',
                    style: 'margin-left:0px !important; background-color: #16A2B7; color: white',
                    icon: 'fa fa-map-marker',
                    label: ' SigPAC',
                    function: () => this.openSigpac()   
                }
                ],
                order: 4
            },
            {
                name: 'Datos generales',
                width: 12,
                isVisible: true,
                fields: this.getDatosGeneralesFields(),
                order: 5
            },
            {
                name: 'Puntos de captación de agua',
                width: 6,
                isVisible: this.env.showDatosMedioambientales,
                fields: this.getDatosMedioambientalesFields(this.env.showDatosMedioambientales),
                order: 6
            },
            {
                name: 'Parcelas en zonas específicas',
                width: 6,
                isVisible: this.env.showDatosMedioambientales,
                fields: this.getZonasEspecificasFields(this.env.showDatosMedioambientales),
                order: 7
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getHiddenFields(),
                order: 8
            }
        ];
        return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private getHiddenFields() {
        const hiddenFields: FormField<any>[] = [
            {
                name: 'id',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.model.id,
                    isEditable: false
                },
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true,
                },
                order: 1
            },
            {
                name: 'id_cliente',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: this.cliente?.id ? this.cliente?.id : this.lists.fincas.selected?.id_cliente,
                    isEditable: false
                },
                updateValue: () => this.cliente?.id ? this.cliente?.id : this.lists.fincas.selected?.id_cliente,
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: this.env.hasClients
                },
                order: 2
            },
            {
                name: 'id_usuario',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    defaultValue: !this.env.showTareasMto ? 
                        this.usuario ? this.usuario.id :
                            (this.lists.fincas.selected || {})?.id_usuario : 
                        !FormType.EDITION ? this.usuario.id : '',
                    isEditable: false
                },
                updateValue: () => !this.env.showTareasMto ? 
                    this.usuario ? this.usuario.id :
                        (this.lists.fincas.selected || {})?.id_usuario : 
                    !FormType.EDITION ? this.usuario.id : '',
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                order: 3
            },
            {
                name: 'cultivo',
                vinculatedFields: ['id_cultivo', 'id_cultivo_legacy'],
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                updateValue: () => {
                    if (!this.env.showCultivosVariedadesPropios) {
                        return this.lists.cultivos.selected?.cultivo ?? this.model.cultivo ?? '';
                    } else {
                        return (this.env.hasPlantas || !this.env.activateApiSIEX)
                            ? this.lists.cultivosLegacy.selected?.cultivo ?? this.model.cultivo ?? ''
                            : this.lists.cultivos.selected?.cultivo ?? this.model.cultivo ?? '';
                    }
                },
                order: 4
            },
            {
                name: 'variedad',
                vinculatedFields: ['id_variedad', 'id_variedad_legacy'],
                label: '',
                input: {type: InputType.HIDDEN, isEditable: false},
                width: 2,
                conditions: {
                    isRememberedOnDuplicate: true,
                    isRequired: false,
                    isRetained: false,
                    hasUndoEnabled: false,
                    isVisible: true
                },
                updateValue: () => {
                    if (!this.env.showCultivosVariedadesPropios) {
                        return this.lists.variedades.selected?.variedad ?? this.model.variedad ?? '';
                    } else {
                        return (this.env.hasPlantas || !this.env.activateApiSIEX)
                            ? this.lists.variedadesLegacy.selected?.variedad ?? this.model.variedad ?? ''
                            : this.lists.variedades.selected?.variedad ?? this.model.variedad ?? '';
                    }
                },
                order: 5
            },
        ];

        if (this.formType === FormType.DUPLICATION) {
            hiddenFields.splice(1, 1);
        }

        return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private getPatron(cultivo: string) {
        switch (cultivo) {
        case 'aguacate': return this.lists.patronAguacate;
        case 'almendro': return this.lists.patronAlmendro;
        case 'cerezo': return this.lists.patronCerezo;
        case 'ciruelo': return this.lists.patronCiruelo;
        case 'cítrico': return this.lists.patronCitricos;
        case 'cítrico mandarino': return this.lists.patronCitricos;
        case 'clementina': return this.lists.patronCitricos;
        case 'lima': return this.lists.patronCitricos;
        case 'limoneros': return this.lists.patronCitricos;
        case 'mandarinos': return this.lists.patronCitricos;
        case 'mandarino': return this.lists.patronCitricos;
        case 'mandarino híbrido': return this.lists.patronCitricos;
        case 'mango': return this.lists.patronMango;
        case 'manzano': return this.lists.patronManzano;
        case 'melocotonero': return this.env.appName === 'agropedbel' ?
            this.lists.patronMelocotoneroParaguayo :
            this.lists.patronMelocotonero;
        case 'naranjos': return this.lists.patronCitricos;
        case 'naranjo': return this.lists.patronCitricos;
        case 'nogal': return this.lists.patronNogal;
        case 'pera': return this.lists.patronPera;
        case 'peral': return this.lists.patronPera;
        case 'pomelo': return this.lists.patronCitricos;
        case 'pomelos': return this.lists.patronCitricos;
        case 'viña': return this.lists.patronVina;
        case 'paraguayo': return this.lists.patronMelocotoneroParaguayo;
        default: if (this.env.appName === 'momparler') { return this.lists.formatoMomparler; } else { return this.lists.patron; };
        }
    }

    private abreMapa() {
        this.mapaOpened = true;

        if (!this.lists.fincas.selected?.id) {
            alert('Debe seleccionar una Finca!');
            return;
        }

        const cultivoSelected = this.env.activateApiSIEX ? this.lists.cultivos.selected?.id : this.lists.cultivosLegacy.selected?.id;
        const variedadSelected = this.env.activateApiSIEX ? this.lists.variedades.selected?.id : this.lists.variedadesLegacy.selected?.id;
        if (!cultivoSelected) {
            alert('Debe seleccionar un Cultivo!');
            return;
        }
        if (!variedadSelected && !this.env.variedadCanBeVarios) {
            alert('Debe seleccionar una Variedad!');
            return;
        }

        this.mapaAbierto = !this.mapaAbierto;
        this.finca = this.lists.fincas.selected?.nombre;
        this.localidad = this.lists.fincas.selected?.localidad || '';

        this.cultivo = this.lists.cultivos.selected?.cultivo ?? '';

        if (this.env.variedadCanBeVarios && !this.model.id_variedad) {
            this.variedad = 'Varios';
        } else {
            this.variedad = this.lists.variedades.selected?.variedad ?? '';
        }
        this.parcelaNombre = this.model.nombre || '';
    }

    private openSigpac() {
        this.sigpacDialog?.openDialog();
    }
}